<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
  }
}
</script>

<style>
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* user-select: none; */
}
li{
  list-style: none;
}
body {
  margin: 0px;
  height: 100%;
}
html {
  height: 100%;
}
#app {
  font-family: Microsoft YaHei, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>
